export const ResponseType = {
  List: 'list',
  Single: 'single'
};
